import _ from 'lodash';

import { canUseDOM } from './dom';

export default function getReduxInitial(prop, defaultValue) {
  if (canUseDOM()) return _.get(window, `REDUX_INITIAL.${prop}`, defaultValue);
  return defaultValue;
}
